import _ from 'underscore'
import axios from 'axios'
import { log } from '@/services/logService.js'

const API = process.env.BASE_URL

let users = []
let couriers = []
let messages = []

function addNewOrUpdateExisting (items, item) {
  let existingItem = _.findWhere(items, { id: +item.id })
  if (existingItem) {
    _.extend(existingItem, item)
    return existingItem
  } else {
    items.push(item)
    return item
  }
}

export default {
  updateCurrentUser: function (user) {
    // copy object and rewrite roles object to string
    let u = JSON.parse(JSON.stringify(user))
    u.roles = u.roles ? u.roles.join(',') : null
    return axios.patch(API + '/me', u).then(response => {
      return response.data
    })
  },
  updateAndroidRegistration: function (registration) {
    return axios.put(API + '/me/android-registration', {'registration': registration}).then(response => {
      return response.data
    }, (error) => {
      log('updateAndroidRegistration error', error)
    })
  },
  updateOnlineStatus: function (online) {
    return axios.put(API + '/me/online', {'online': online}).then(response => {
      return response.data
    }, (error) => {
      log('update online status error', error)
    })
  },
  getUsers: function () {
    axios.get(`${API}/users`).then(response => {
      users.length = 0
      users.push(...response.data.users)
    })
    return users
  },
  getCouriers: _.throttle(function () {
    axios.get(`${API}/couriers`).then(response => {
      response.data.couriers.forEach(courier => addNewOrUpdateExisting(couriers, courier))
    })
    return couriers
  }, 5000),
  getCouriersPromise: _.throttle(function () {
    return axios.get(`${API}/couriers`).then(response => {
      response.data.couriers.forEach(courier => addNewOrUpdateExisting(couriers, courier))
      return couriers
    })
  }, 5000),
  getTransactions: function () {
    let transactions = []
    axios.get(`${API}/me/transactions`).then(response => {
      transactions.push(...response.data.transactions)
    })
    return transactions
  },
  updateUser: function (user) {
    user.exclusive_courier_id = user.exclusive_courier_id || null
    user.proxy_id = user.proxy_id || null
    return axios.patch(`${API}/users/${user.id}`, user).then(response => {
      return response.data
    })
  },
  recharge: function (userId, transaction) {
    return axios.post(`${API}/users/${userId}/transactions`, transaction).then(response => {
      return response.data
    })
  },
  getMessages: function () {
    axios.get(`${API}/messages`).then(response => {
      response.data.messages.forEach(message => addNewOrUpdateExisting(messages, message))
    }, error => {
      console.log(error)
    })
    return messages
  },
  getUnreadMessagesCount: function () {
    console.log('message count')
    return messages.reduce((acc, cur) => acc + cur.read ? 0 : 1, 0)
  },
  markMessagesRead: function () {
    messages.forEach(message => { message.read = true })
    const latestMessageId = _.max(messages, function (message) { return message.id }).id
    axios.post(`${API}/messages/${latestMessageId}/read`)
  }
}
